import React from 'react';
import { MdEdit } from 'react-icons/md';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import {
  HeadingWithCreateBtn,
  Modal,
  Radio,
  Search,
  TextField,
  Table,
} from 'src/components';

import { DashboardLayout } from 'src/containers';
import CrudIcon from 'src/components/crud-icon';
import AddEdit from './crud/AddEdit';
import { PiPencil } from 'react-icons/pi';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchDesignation } from 'src/redux/action/designation.action';
import { useDispatch } from 'react-redux';
import { AiOutlinePlus } from 'react-icons/ai';
import Button from 'src/components/button';
import useFetch from 'src/hooks/useFetch';

interface IProps {}

const Designation: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [query, setQuery] = React.useState('');
  const [editData, setEditData] = React.useState(false);
  const [editDataId, setEditDataId] = React.useState('');
  const [designationEditData, setDesignationEditData] = React.useState({});

  // designation
  const dispatch = useDispatch();

  const { designationData } = useSelector(
    ({ designationData }: RootState) => designationData,
    shallowEqual
  );

  React.useEffect(() => {
    if (designationData.length > 0) return;
    dispatch(fetchDesignation() as any);
  }, [dispatch]);

  const searchDesignationData = designationData?.filter((item) => {
    if (query === '') {
      return item;
    } else if (item) {
      return item?.name?.toLowerCase().includes(query.toLowerCase());
    }
  });

  const handleAddModal = () => {
    setEditData(false);
    setEditDataId('');
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
    setDesignationEditData({});
  };

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const handleEdit = (data: any) => {
    setDesignationEditData(data);
    setEditData(true);
    setEditDataId(data.id);
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
  };

  const {
    data: itemsData,
    fetchData,
    isLoading,
    errorText,
  } = useFetch('/designations');
  const tableColumn = [
    { Header: 'Designation Title', accessor: 'name' },

    { Header: 'Employees no.', accessor: 'employeeCount' },
    {
      Header: 'Action',

      Cell: (row: any) => (
        <CrudIcon
          data={row?.cell?.row?.original}
          fetchData={fetchDesignation() as any}
          url="/designations/remove"
        >
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handleEdit(row?.cell?.row?.original)}
          >
            <PiPencil color="#4062FF" />
          </div>
        </CrudIcon>
      ),
    },
  ];

  return (
    <>
      <div className="grid-cols-12 grid gap-7">
        <div className="col-span-12">
          {/* <HeadingWithCreateBtn
            icon={<AiOutlinePlus size={20} />}
            btnTxt="create designation"
            title="designation"
            onClick={() => setShowModal(!showModal)}
          />
          <Search
            placeholder="search designation"
            query={query}
            setQuery={setQuery}
          /> */}
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search designation"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add Designation'}
              variant="primary"
              onClick={() => {
                handleAddModal();
                setEditData(false);
                setEditDataId('');
              }}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          <Table
            loading={isLoading}
            tableColumn={tableColumn}
            tableData={searchDesignationData}
          />
        </div>

        <AddEdit
          designationEditData={designationEditData}
          handleModal={handleModal}
          showModal={showModal}
          editData={editData}
          editDataId={editDataId}
          setEditData={setEditData}
          setEditDataId={setEditDataId}
        />
      </div>
    </>
  );
};

export default React.memo(Designation);
